import React, {Fragment} from 'react'
import styled from 'styled-components';
import { Collapsible } from './Collapsible'

import Helmet from "react-helmet"


const getStructuredData = (content) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": content.map(({question, answer}) => {
      const abc = {
        "@type": "Question",
        "name": question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text":  answer
        }
      }
      return abc
    })
  }

}

const Faq = ({title, content}) => {
  const structuredData = JSON.stringify(getStructuredData(content))

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {structuredData}
        </script>
        
      </Helmet>
      <FAQWrapper>
        <HeaderTitle $center >{title}</HeaderTitle>
        {content.map(({question, answer},index) => 
          <Collapsible key={index} question={question} answer={answer}/>
        )}
      </FAQWrapper>
    </>
  )
}

export default Faq


const HeaderTitle = styled.h2`
  font-size: 3rem;
  ${props => props.$center ? 'text-align:center;' : ''}
  @media ${props => props.theme.phoneLand} {
    font-size: 2rem;
    text-align:center;
  }
`

const FAQWrapper = styled.div`
  max-width:1000px;
  margin: 0px auto 50px auto;
  display:flex;
  flex-direction:column;
  justify-content:center;
  @media ${props => props.theme.tabletBelow}{
    max-width:90%;
  }
`